/**
 * NGX Insights
 *
 *   Insights.track('type:object', {Object});
 *   Insights.listen('type:object', {Function});
 *
 *   // TODO! add to our tracking - is this actually required, since we can track unreg'd events?
 *   Insights.register('type:object');
 *
 *   Privacy Management Note: Insights may be sent without analytics consent because they can be anonymous in that case.
 */

import { createCORSRequest } from '../utils/utils';
import { createNgxUUID } from '../utils/formUtils';

import enums from '../../common/config/enums';
import TrackingService from 'display/common/services/TrackingService';

export default (function(w, d, $, undefined) {
  'use strict';

  var conf = NGX.config,
    cntx = NGX.context;

  var eventBus,
    defaults,
    optional,
    alias = {
      e: {
        // event
        view:       'v',
        share:      's',
        retweet:    's',
        invite:     'i',
        conversion: 'g',
        referral:   'r',
        click:      'ct',
        consume:    'c',
        vote:       'vo',
        network:    'n',
        x:          'x',
        comment:    'cm',
        reply:      'cm',
        like:       'lk',
        favorite:   'lk',
        upvote:     'lk',
        plusone:    'lk',
        redirect:   'a',
      },
      o: {
        // object
        campaign:         'c',
        display:          'd',
        promo:            'p',
        likeGate:         'g',
        secondaryCta:     's',
        promotionDetails: 'pd',
        media:            'm',
        channel:          'ch',
        medium:           'med',
        source:           'src',
        link:             'link',
        details:          'dt',
        contentitem:      'ci',
        entries:          'ci',
        x:                'x',
      },
    },
    rules = {
      v: {
        // object: [required params]
        // ** where's the definition of the required params?
        c:  ['c', 'i', 'dc', 'h'],
        d:  ['dc', 'h'],
        p:  ['c', 'p', 'dc', 'h'],
        g:  ['dc', 'h'],
        ch: ['h'],
        ci: ['c', 'h', 'dc', 'i'],
      },
      ct: {
        p:  ['c', 'p', 'dc', 'h'],
        s:  ['c', 'p', 'dc', 'h'],
        ci: ['c', 'dc', 'h', 'link'],
      },
      i: {
        c: ['c', 'p', 'dc', 'h'],
      },
      s: {
        c:  ['c', 'p', 'dc', 'h'],
        ci: ['c', 'dc', 'h', 'a', 'i'],
      },
      lk: {
        ci: ['ci', 'c', 'dc', 'h', 'a'],
      },
      cm: {
        ci: ['ci', 'c', 'dc', 'h', 'a'],
      },
      a: {
        ci: ['c', 'i', 'h', 'link'],
      },
    },
    /**
     * Event bus Class
     * @param {String} id (we don't do anything with this, but would let us run concurrent buses)
     */
    Bus = function(id) {
      this.id = id;
      this.url = NGX.App.config.insightUrl + '/api/trace/d/record?';
      this.delay = 200;
      _.extend(this, Backbone.Events); // underscore extend for Backbone.Events
      return this;
    },
    /**
     * Create query string
     * @param {Object} event parameter key:value pairs
     */
    buildQueryString = function(params) {
      var obj = $.extend({}, defaults, params), // jQuery extend is faster for simple objects than underscore/lodash in webkit. hipster libraries < browser vendors.
        qs = '',
        prop,
        propVal,
        noCache = '&' + Math.floor(Math.random() * 10000),
        userName = 'Anonymous';
      const allowCookies = NGX.PrivacyManager.doAllowActionType(enums.PRIVACY_TYPES.ANALYTICS);

      // add user's FB name if we have it & privacy consent allows it
      if (allowCookies && NGX.App.state.currentUser.userProfile) {
        // WYN-7164 Privacy consent - If we allow analytics cookies, then we may append the user's profile name, otherwise use anonymous.
        // Honestly, I'm not sure that userProfile is even being used anymore?  Might be left over from loyalty and gamification?
        userName = NGX.App.state.currentUser.userProfile.name || userName;
      }
      obj.u = userName;

      // process the object to create the string
      for (prop in obj) {
        // yeah there is an assignment in this condition. ignore JSHint, it's absolutely fine because i just told you about it. move along please.
        if (obj.hasOwnProperty(prop) && (propVal = obj[prop])) {
          // only accept strings and numbers here
          if (/(string|number)/.test(typeof propVal)) {
            qs += prop + '=' + encodeURIComponent(propVal) + '&';
          }
        }
      }

      // cleanup the URL, append noCache and return
      return (/&$/.test(qs) ? qs.substring(0, qs.length - 1) : qs) + noCache;
    },
    /**
     * Map parameter values
     * @param {Object} event parameter key:value pairs
     */
    paramsValMap = function(params) {
      var obj = {},
        // rename a parameter and it's content using alias and remove old property so we can extend using params
        nameMap = function(a, b) {
          if (params[a]) {
            obj[b] = alias[b][params[a]];
            delete params[a];
          }
          return obj[b];
        },
        // add required parameters for an event/object combo
        paramsRequired = function(e, o) {
          var req = rules[e] ? rules[e][o] : [],
            item,
            i = 0,
            len = req ? req.length : 0;
          for (; i < len; i++) {
            if ((item = req[i])) {
              obj[item] = optional[item];
            }
            item = false;
          }
        };

      paramsRequired(nameMap('event', 'e'), nameMap('object', 'o'));
      // currently overwrites default parameters with params
      return $.extend(obj, params);
    },
    /**
     * Handle anchor links clicks
     * @param {Object} jQuery event
     */
    linkClick = function(e) {
      var el = e.currentTarget,
        href = el.getAttribute('href'),
        targ = el.getAttribute('target'),
        clss = el.getAttribute('class'),
        action = el.getAttribute('data-ngx-action'),
        // open link location in it's specified target attribute
        openInTarg = function(targ) {
          var targStr;
          if (targ) {
            targStr = (targ[0] === '_' ? targ.substring(1) : targ).toLowerCase();
            // open in a new window
            if (targStr === 'blank') {
              var win = w.open(href, targ);
              if (win) {
                win.focus();
              }
              return false;
            } else if (w[targStr]) {
              // window.self.location, window.top.location, window.parent.location...
              w[targStr].location.href = href;
              return false;
            }
          }
          // if all else fails...
          w.location.href = href;
          return false;
        };
      // do not do anything if there is no href, the href="#" or it has data-ngx-action="route"
      if (!!href && href[0] !== '#' && action !== 'route') {
        e.preventDefault();
        // default params for a click (!! to handle null or "")
        Insights.track('click:' + (!!clss && clss.indexOf('xCTA') ? 'secondaryCta' : 'link'), {
          callback: function() {
            openInTarg(targ);
          },
        });
      }
    },
    /**
     * create an image
     */
    tempImg = function(src) {
      // image does not need to be attached to the DOM to load the SRC
      return TrackingService.trackingImage(src);
    },
    /**
     * Create a cors request
     */

    corsRequest = function(obj, callback) {
      // Define query string params to send with tracking url.
      var params = {
        ic:        1,
        contentId: obj.i,
        apikey:    cntx.apikey,
        fbid:      NGX.App.state.currentUser.fbid,
        channelId: cntx.channel && cntx.channel.id ? cntx.channel.id : '',
        target:    obj.target,
        source:    obj.source,
        medium:    obj.medium,
        channel:   obj.channel,
      };

      // WYN-4077 Some params need to change based on interaction strategy.
      switch (NGX.App.config.interactionStrategy) {
        case 'interaction.partition':
          params.campaignObjectId = conf.id;

          // If no UID is set in context (retrieved from ngx cookie), then generate a new random one.
          var uid = NGX.context.uid || '';
          if (!uid) {
            // 33 chars in length, first character 'r'.
            uid =
              'r' +
              createNgxUUID()
                .split('-')
                .join('');
          }
          params.uid = uid;
          break;

        default:
          // cID is the campaign id
          params.cID = conf.id;
      }

      var request = createCORSRequest('POST', conf.sharing.updateURL + '?' + $.param(params));
      if (request) {
        request.send();
        if ('function' === typeof callback) {
          callback.call(this);
        }
      }
    },
    /**
     * initialise tracker
     */
    initialise = function(options) {
      // populate default values
      defaults = $.extend(
        {},
        {
          t:       NGX.context.apikey,
          channel: NGX.context.track.channel ? NGX.context.track.channel : '',
          medium:  NGX.context.track.medium ? NGX.context.track.medium : '',
          source:  NGX.context.track.source ? NGX.context.track.source : '',
        },
        options
      );
      // populate optional values (rule-driven)
      optional = {
        dc: NGX.context.displayContainer ? NGX.context.displayContainer.id : '',
        c:  NGX.App.config ? NGX.App.config.id : '',
        // these don't actually exist
        p:  NGX.context.promotion ? NGX.context.promotion.id : '',
        h:  NGX.context.channel ? NGX.context.channel.id : '',
      };
      // instantiate new tracking instance
      eventBus = new Bus('ngxDefault');
      // register default event types
      eventBus.registerEvents(
        [
          'x:x',
          'view:channel',
          'view:campaign',
          'view:display',
          'view:promo',
          'view:likeGate',
          'view:secondaryCta',
          'view:media',
          'view:promotionDetails',
          'view:contentitem',
          'click:link',
          'click:secondaryCta',
          'click:promo',
          'click:contentitem',
          'consume:media',
          'vote:campaign',
          'vote:contentitem',
          'retweet:contentitem',
          'reply:contentitem',
          'favorite:contentitem',
          'share:display',
          'share:contentitem',
          'share:entries',
          'share:promotion',
          'invite:display',
          'redirect:contentitem',
        ],
        'track'
      );

      // Register the two different track event types
      eventBus.registerEvents(['share:campaign'], 'trackShare');
      eventBus.registerEvents(['invite:campaign'], 'trackInvite');
    };

  /**
   * Add tracking to named events
   * @param {Object} eventList can contain an array of strings or a single string
   */
  Bus.prototype.registerEvents = function(eventList, method) {
    var i = 0,
      len,
      cn;
    if (eventList) {
      cn = eventList.constructor;
      if (cn === Array) {
        len = eventList.length;
        for (; i < len; i++) {
          this.on(eventList[i], this[method]);
        }
      } else if (cn === String) {
        this.on(eventList, this[method]);
      }
    }
  };

  /**
   * Track event
   * @param {Object} Event parameters
   */
  Bus.prototype.track = function(params, queued) {

    // build the query string
    var obj = paramsValMap(params),
      qs = buildQueryString(obj);
    // fire off the server request
    this.img = tempImg.call(this, this.url + qs);
    // trigger callback in global score if specified (passed the image)
    if (params.callback && params.callback.constructor === Function) {
      setTimeout(function() {
        params.callback(this.img);
      }, this.delay);
    }
  };

  /**
   * Track Share event
   * @param {Object} Event parameters
   */
  Bus.prototype.trackShare = function(params, queued) {

    // If we don't have analytics consent, we won't send a track share at all, since the
    // /api/interact/d/share endpoint requires a uid and doesn't make sense without it.
    const allowCookies = NGX.PrivacyManager.doAllowActionType(enums.PRIVACY_TYPES.ANALYTICS);
    if (!allowCookies) return;

    // build the query string
    var obj = $.extend({}, defaults, paramsValMap(params));

    if (NGX.App.config.sharing.updateURL) {
      // modified updateShares code

      // fire off the server request
      corsRequest.call(this, obj, function() {
        // trigger callback in global score if specified (passed the image)
        if (params.callback && params.callback.constructor === Function) {
          setTimeout(function() {
            params.callback(this.img);
          }, this.delay);
        }
      });
    } else {
      // Do what here?
    }
  };

  // Public API
  return {
    //Events : eventBus, // do not expose this
    init:  initialise, // called at end of _page_display_context.gsp
    track: function(eventName, params) {
      if (!eventBus) return;
      var evtObj = eventName.split(':'),
        paramObj = {
          event:  evtObj[0],
          object: evtObj[1],
        };
      // we enforce the event/object name even if an alternative is passed
      eventBus.trigger(eventName, $.extend({}, params, paramObj));
    },
    listen: function(eventName, fn) {
      if (!eventBus) return;
      if (eventName && fn.constructor === Function) {
        eventBus.on(eventName, fn);
      }
    },
    register: function(params) {
      if (!eventBus) return;
      eventBus.registerEvents(params);
    },
  };
})(window, document, $);
